<template>
    <div class="row google-map">
        <div class="col-sm-12 mb-4">
            <div v-if="center.lat" class="gmap-iframe ratio ratio-4x3 ratio-sm-21x9" lc-helper="gmap-embed">
                <gmap-map
                    :zoom="16"    
                    :center="center"
                    style="width:100%;  height: 600px;"
                >
                    <gmap-marker
                        v-for="(m, index) in locationMarkers"
                        :key="index"
                        :position="m.position"
                        @click="center=m.position"
                    ></gmap-marker>
                </gmap-map>
            </div>
        </div>
        <div class="col-md-12">
            <div class="uk-margin">
                <div class="uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: location"></span>
                    <gmap-autocomplete @place_changed="addLocationMarker" placeholder="" class="uk-input" required></gmap-autocomplete>
                    <input type="hidden" name="address" v-model="formData.address">
                    <label class="ml-5"> Address </label>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group select-box">
                <input type="text" name="country" v-model="formData.country" class="form-control" required>
                <label>Country</label>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group select-box">
                <input type="text" name="province" v-model="formData.province" class="form-control" required>
                <label>Province</label>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <input type="text" name="district" v-model="formData.district" class="form-control" required>
                <label>District</label>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <input type="text" name="sub_district" v-model="formData.sub_district" class="form-control">
                <label>Sub District</label>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <input type="text" name="zip_code" v-model="formData.zip_code" class="form-control" required>
                <label> Zip code </label>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <input type="url" name="website" v-model="formData.website" class="form-control" required>
                <label> Website </label>
            </div>
        </div>
    </div>
</template>
 
<script>
export default {
    data() {
        return {
            formData: {
                lat: 13.740622391580136,
                lng: 100.55779496911425,
                address: '',
                sub_district: '',
                district: '',
                province: '',
                country: '',
                zip_code: null,
                website: '',
            },
            center: { 
                lat: 13.740622391580136,
                lng: 100.55779496911425,
            },
            locationMarkers: []
        };
    },
    mounted() {
        console.log(this.formData)
        this.setMapLocaiton()
    },
    methods: {
        setMapLocaiton() {
            // navigator.geolocation.getCurrentPosition(res => {
                // console.log(res.coords.latitude)
            this.center.lat = parseFloat(this.formData.lat)
            this.center.lng = parseFloat(this.formData.lng)
              
            // });

            this.locationMarkers = []
            this.locationMarkers.push({ position: this.center })

            console.log(this.center)
            console.log(this.locationMarkers)
        },
        addLocationMarker(location) {
            console.log(location)
            this.formData = {}
            if (location) {
                this.center = {
                    lat: location.geometry.location.lat(),
                    lng: location.geometry.location.lng()
                };
                this.locationMarkers = []
                this.locationMarkers.push({ position: this.center })
                this.formData.address = location.formatted_address
                this.formData.lat = location.geometry.location.lat()
                this.formData.lng = location.geometry.location.lng()
                this.formData.website = location.website
                location.address_components.forEach(address => {
                    if(address.types.includes('country')) {
                        this.formData.country = address.long_name
                    }
                    else if(address.types.includes('postal_code')) {
                        this.formData.zip_code = address.long_name
                    }
                    else if(address.types.includes('locality')) {
                        this.formData.province = address.long_name
                    }
                    else if(address.types.includes('administrative_area_level_1') || address.types.includes('sublocality_level_1')) {
                        this.formData.district = address.long_name
                    }
                    else if(address.types.includes('administrative_area_level_2') || address.types.includes('sublocality_level_2')) {
                        this.formData.sub_district = address.long_name
                    }
                });
            }
        },
    }
};
</script>

<style scoped>
    .google-map .save-btn{
        border: 0px;
    }
</style>